var $cea8e4747c5e6c53$exports = {};
const $cea8e4747c5e6c53$var$emailCopyJsEmailButton = document.querySelector(".emailbtn");
const $cea8e4747c5e6c53$var$emailCopyJsToast = document.getElementById("toast");
if ($cea8e4747c5e6c53$var$emailCopyJsEmailButton) $cea8e4747c5e6c53$var$emailCopyJsEmailButton.addEventListener("click", function() {
    if (navigator.clipboard) navigator.clipboard.writeText("info@chesscoordinates.com").then(()=>{
        $cea8e4747c5e6c53$var$emailCopyJsToast.innerHTML = "copied!</br>info@chesscoordinates.com";
        $cea8e4747c5e6c53$var$emailCopyJsToast.classList.remove("toast-hidden");
        setTimeout(()=>$cea8e4747c5e6c53$var$emailCopyJsToast.classList.add("toast-hidden"), 4000);
    }).catch(()=>{
        $cea8e4747c5e6c53$var$emailCopyJsToast.innerHTML = "contact me at</br>info@chesscoordinates.com";
        $cea8e4747c5e6c53$var$emailCopyJsToast.classList.remove("toast-hidden");
        setTimeout(()=>$cea8e4747c5e6c53$var$emailCopyJsToast.classList.add("toast-hidden"), 4000);
    });
    else {
        $cea8e4747c5e6c53$var$emailCopyJsToast.innerHTML = "contact me at</br>info@chesscoordinates.com";
        $cea8e4747c5e6c53$var$emailCopyJsToast.classList.remove("toast-hidden");
        setTimeout(()=>$cea8e4747c5e6c53$var$emailCopyJsToast.classList.add("toast-hidden"), 4000);
    }
});


//# sourceMappingURL=404.910336f7.js.map
